<template>
  <div :class="containerClass">
    <div class="form-item-title" :style="titleStyle">{{ title }}</div>
    <div :class="contentClass">
      <slot></slot>
    </div>
  </div>
</template>
<script lang="ts" setup>
import {
  computed,
} from "vue"

const props = withDefaults(defineProps<{
  title: string,
  titleWidth?: number
  vertical?: boolean
}>(), {
  vertical: false
})

const titleStyle = computed(() => {
  let result = {
    "flex-shrink": 0
  } as any
  if (props.titleWidth) {
    result["width"] = `${props.titleWidth}px`
  } 
  if (props.vertical) {
    result["font-weight"] = "500"
  }
  return result
})

const containerClass = computed(() => {
  return {
    "form-item-container": true,
    "flex-row-nowrap-start-start-start": !props.vertical,
    "flex-col-nowrap-start-start-start": props.vertical,
  }
})

const contentClass = computed(()=> {
  return {
    "form-item-content": !props.vertical,
    "form-item-content-vertical": props.vertical
  }
})

</script>
<style scoped>
.form-item-title {
  min-width: 80px;
  margin-right: 8px;
  min-height: 34px;
  padding-top: 6px;
  box-sizing: border-box;
}

.form-item-container {
  width: 100%;
  padding-bottom: 8px;
  min-height: 34px;
}

.form-item-content {
  flex-grow: 1;
}
.form-item-content-vertical {
  width: 100%;
}
</style>
